(() => {
  'use strict';
  // Preserve the original capture-phase interception to avoid duplicate pixel events.
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.gr-product-form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('[data-atc-btn]');
    if (!button || button.disabled) return;
    const original = button.textContent;
    let error = form.parentNode.querySelector('.ev18-form-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'ev18-form-error';
      error.setAttribute('role', 'alert');
      form.after(error);
    }
    error.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    const fields = new FormData(form);
    const payload = { id: Number(fields.get('id')), quantity: Number(fields.get('quantity') || 1) };
    if (fields.get('selling_plan')) payload.selling_plan = Number(fields.get('selling_plan'));
    const properties = {};
    for (const [key, value] of fields) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    }
    if (Object.keys(properties).length) payload.properties = properties;
    try {
      if (!Number.isSafeInteger(payload.id) || payload.id < 1) throw new Error('Please select an available option.');
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'This option could not be added. Please try again.');
      button.textContent = 'Taking you to checkout…';
      window.location.assign('/checkout');
    } catch (failure) {
      error.textContent = failure.message === 'Failed to fetch' ? 'Connection interrupted. Please try again.' : (failure.message || 'We couldn’t add this option. Please try again.');
      error.hidden = false;
      button.textContent = original;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);

  const videos = [...document.querySelectorAll('[data-ev18-video]')];
  const play = video => { video.muted = true; video.play().catch(() => {}); };
  videos.forEach(play);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) videos.forEach(play);
  });

  const sticky = document.querySelector('[data-ev18-sticky]');
  const hero = document.getElementById('product-intro');
  const offers = [...document.querySelectorAll('[data-ev18-offer]')];
  const footer = document.getElementById('ev18-footer');
  const consent = () => document.querySelector('#shopify-pc__banner')?.getBoundingClientRect().height > 0;
  const updateSticky = () => {
    if (!sticky || !hero || !offers.length) return;
    const offerVisible = offers.some(el => { const r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; });
    sticky.hidden = hero.getBoundingClientRect().bottom > 0 || offerVisible || footer.getBoundingClientRect().top < innerHeight || consent();
  };
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky, { passive: true });
  updateSticky();
  new MutationObserver(updateSticky).observe(document.body, { childList: true });
})();
